<!DOCTYPE html>
<!--
To change this license header, choose License Headers in Project Properties.
To change this template file, choose Tools | Templates
and open the template in the editor.
-->
<html xmlns:th="http://www.thymeleaf.org">

<head>
    <title>SBM</title>
    <meta charset="UTF-8">
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0"> 
</head>

<body id="body">
    <header>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="logo">
                        <img src="assets/logo.png" alt="" />
                    </div><!-- /.logo -->
                </div><!-- /.col-md-4 -->
            </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </header>
    <section id="content">
        <div class="login">
            <div class="login-overlay">
                <div class="login-box">
                    <form [formGroup]="authForm" (ngSubmit)="checkLogin()" id="myform" method="post">
                        <div>
                            <!--<div class="alert alert-danger" *ngIf="errorMsg" >
                                <h3>{{errorMsg}}</h3>
                            </div> -->
                            <div class="alert alert-danger" *ngIf="invalidLogin" >
                                Invalid username or password.
                            </div>
                        </div>
                        <div *ngIf="invalidLogin">
                            <div class="alert alert-info">
                                You have been logged out.
                            </div>
                        </div>
                        <div *ngIf="resetPassword">
                            <div class="alert alert-info">
                                Please Change Your Password !!!
                            </div>
                        </div>
                        <div *ngIf="notMatchedNewPassword">
                            <div class="alert alert-danger">
                                New Passwords does not match!
                            </div>
                        </div>
                        <div class="login-form">
                            <div class="input-group">
                                <input type="email" formControlName="email" placeholder="username"  name="username" id="username">
                                <label for="username">User Name</label>
                            </div>
                            <div class="input-group">
                                <input type="password" placeholder="Password" formControlName="password" name="password" id="password">
                                <label for="password">Password</label>
                            </div>
                            <div class="input-group"  *ngIf="resetPassword">
                                <input type="password" placeholder="New Password" name="newPassword" id="newPassword">
                                <label for="newPassword">Enter New Password</label>
                            </div>
                            <div class="input-group"  *ngIf="resetPassword">
                                <input type="password" placeholder="Confirm Password " name="confirmPassword" id="confirmPassword">
                                <label for="confirmPassword">Confirm New Password</label>
                            </div>
                            <div class="btns">
                                <input type="submit" name="login-submit" id="login-submit"
                                    class="form-control btn btn-info" value="Log In">
                            </div>
                            <input type="hidden"
							   name="@{_csrf.parameterName}"
							   value="@{_csrf.token}" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</body>

</html>